<template lang="pug">
  .indexBox
    .header
      h1
        img(src="../assets/img/logo.png" alt="")
      .nav
        ul
          li
            a(href="javascript:;" @click="goHome" :class="[this.$store.state.flag==1?'bdBlue':'']") 网站首页
          li
            a(href="javascript:;" @click="goProduct" :class="[this.$store.state.flag==2?'bdBlue':'']") 业务产品
          li
            a(href="javascript:;" @click="goSlution" :class="[this.$store.state.flag==4?'bdBlue':'']") 解决方案
          li
            a(href="javascript:;" @click="goCase" :class="[this.$store.state.flag==3?'bdBlue':'']") 成功案例
          li
            a(href="javascript:;" @click="goNews" :class="[this.$store.state.flag==5?'bdBlue':'']") 新闻资讯
          li
            a(href="javascript:;" @click="goContact" :class="[this.$store.state.flag==6?'bdBlue':'']") 客户服务
          li
            a(href="javascript:;" @click="goWe" :class="[this.$store.state.flag==7?'bdBlue':'']") 关于我们
    <router-view></router-view>
    .quantization
      h4 速云智能办公,让工作更简单
      .button(@click="goMa") 立即体验
    .footer
      .footerLeft
        img(src="../assets/img/logobai.png" alt="")
        ul
          li
            //p 咨询电话：<span>0931-0000000</span>
          li
            //p 咨询电话：<span>0931-0000000</span>
          li
            p 咨询电话：<span>400-0931-866</span>
          li 隐私声明 | 版权所有 © 速云软件 2001-2020 备注号 <a href="https://beian.miit.gov.cn">陇ICP备18000095号-1</a> <img src="http://www.beian.gov.cn/file/ghs.png" alt="#"> <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62010202001828">甘公网安备62010202001828号</a>
      .footerRight
        .barCode
          img(src="../assets/img/weibo.png" alt="")
          h5 官方微博
        .barCode
          img(src="../assets/img/gongzhong.jpg" alt="")
          h5 官方公众号
        .barCode
          img(src="../assets/img/toutiao.jpg" alt="")
          h5 官方头条
    //固定的头部
    .header1(v-if="flag4==true")
      h1
        img(src="../assets/img/logo.png" alt="")
      .nav
        ul
          li
            a(href="javascript:;" @click="goHome" :class="[this.$store.state.flag==1?'bdBlue':'']") 网站首页
          li
            a(href="javascript:;" @click="goProduct" :class="[this.$store.state.flag==2?'bdBlue':'']") 业务产品
          li
            a(href="javascript:;" @click="goSlution" :class="[this.$store.state.flag==4?'bdBlue':'']") 解决方案
          li
            a(href="javascript:;" @click="goCase" :class="[this.$store.state.flag==3?'bdBlue':'']") 成功案例
          li
            a(href="javascript:;" @click="goNews" :class="[this.$store.state.flag==5?'bdBlue':'']") 新闻资讯
          li
            a(href="javascript:;" @click="goContact" :class="[this.$store.state.flag==6?'bdBlue':'']") 客户服务
          li
            a(href="javascript:;" @click="goWe" :class="[this.$store.state.flag==7?'bdBlue':'']") 关于我们
</template>

<script>
export default {
  data () {
    return {
      scrollTop1: 0,
      flag4: false
    }
  },
  methods: {
    handle1 (e) {
      e = e || window.event
      if (e.wheelDelta) {
        if (e.wheelDelta > 0) {
          if (this.scrollTop1 > 93) {
            this.flag4 = true
          } else {
            this.flag4 = false
          }
        } else if (e.wheelDelta < 0) {
          this.flag4 = false
        }
      } else if (e.detail) {
        if (e.detail > 0) {
          if (this.scrollTop1 > 93) {
            this.flag4 = true
          } else {
            this.flag4 = false
          }
        } else if (e.detail < 0) {
          this.flag4 = false
        }
      }
    },
    handleScroll () {
      this.flag2 = false
      this.scrollTop1 = window.pageYOffset
      if (window.pageYOffset > 250) {
        this.flag2 = true
      } else {
        this.flag2 = false
      }
    },
    goWe () {
      window.scroll(0, 0)
      this.$router.push('/we')
    },
    goProduct () {
      window.scroll(0, 0)
      this.$router.push('/product')
    },
    goHome () {
      window.scroll(0, 0)
      this.$router.push('/home')
    },
    goNews () {
      window.scroll(0, 0)
      this.$router.push('/news')
    },
    goSlution () {
      window.scroll(0, 0)
      this.$router.push('/slution')
    },
    goContact () {
      window.scroll(0, 0)
      this.$router.push('/contact')
    },
    goCase () {
      window.scroll(0, 0)
      this.$router.push('/case')
    },
    goMa () {
      window.scroll(0, 0)
      var routeUrl = this.$router.resolve({
        path: '/ma',
        query: {}
      })
      window.open(routeUrl.href, '_blank')
    }
  },
  mounted () {
    document.title = '速云官网'
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('wheel', this.handle1)
    window.addEventListener('DOMMouseScroll', this.handle1)
    window.addEventListener('mousewheel', this.handle1)
  }
}
</script>

<style lang="less" scoped>
  .indexBox{
    width: 100%;
    .header1,.header{
      width: 100%;
      height: 88px;
      background-color: #fff;
      box-shadow: 1px 1px 4px rgba(0, 0, 0, .3);
      h1{
        float: left;
        margin: 25px 0 0 8vw;
        img{
          width: 150px;
        }
      }
      .nav{
        ul{
          float: right;
          margin: 25px 8vw 0 0;
          li{
            float: left;
            padding: 0 20px;
            a{
              display: inline-block;
              height: 44px;
              line-height: 44px;
            }
            a:hover{
              border-bottom: 3px solid #409fee;
            }
          }
        }
      }
      // .icon{
      //   position: relative;
      //   float: left;
      //   margin-top: 3.5vh;
      //   height: 8vh;
      //   line-height: 8vh;
      //   .erweibox{
      //     float: left;
      //   }
      //   .iconweixin{
      //     margin-right: 20px;
      //     cursor: pointer;
      //   }
      //   .erweibox:hover{
      //     .erweima{
      //       display: block;
      //     }
      //   }
      //   .iconxingtaiduICON_sousuo--{
      //     cursor: pointer;
      //   }
      //   .erweima{
      //     position: absolute;
      //     display: none;
      //     bottom: -170px;
      //     left: -105px;
      //     width: 120px;
      //     height: 120px;
      //     padding: 20px;
      //     border-radius: 10px;
      //     background-color: #fff;
      //     border: 1px solid #ccc;
      //     z-index: 9999;
      //     img{
      //       width: 100%;
      //       height: 100%;
      //     }
      //   }
      //   .erweima::before{
      //     content: "";
      //     position: absolute;
      //     top: -11px;
      //     right: 35px;
      //     width: 20px;
      //     height: 20px;
      //     transform: rotate(45deg);
      //     border-top: 1px solid #ccc;
      //     border-left: 1px solid #ccc;
      //     background-color: #fff;
      //   }
      // }
      // input{
      //   height: 25px;
      //   width: 0px;
      //   margin: 25px 0 0 10px;
      //   border: 0;
      //   //border-bottom: 2px solid #666;
      //   outline: none;
      //   font-size: 18px;
      // }
      // input::-webkit-input-placeholder{
      //   color: #999;
      //   font-size: 12px;
      // }
      // input:-moz-placeholder{
      //   color: #999;
      //   font-size: 12px;
      // }
      // input::-moz-placeholder{
      //   color: #999;
      //   font-size: 12px;
      // }
      // input:-ms-input-placeholder{
      //   color: #999;
      //   font-size: 12px;
      // }
    }
    .header1{
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
    }
    .quantization{
      width: 100%;
      text-align: center;
      background-image: url(../assets/img/bc3.png);
      background-size: 100%;
      overflow: hidden;
      h4{
        color: #fff;
        font-size: 28px;
        margin-top: 40px;
        font-weight: 400;
      }
      .button{
        width: 200px;
        height: 40px;
        background-color: #fff;
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        margin: 20px auto 40px;
        font-size: 20px;
        cursor: pointer;
      }
    }
    .footer{
      width: 100%;
      height: 240px;
      background-color: #20242B;
      .footerLeft{
        float: left;
        margin-left: 6%;
        padding-top: 52px;
        img{
          width: 156px;
          height: 39px;
        }
        li{
          margin-top: 22px;
          font-size: 14px;
          color: #fff;
          img{
            width: 15px;
            height: 15px;
            vertical-align: middle;
          }
          a{
            color: #fff;
          }
          p{
            font-size: 16px;
            span{
              color: #017CF8;
            }
          }
        }
      }
      .footerRight{
        float: right;
        margin-right: 6%;
        margin-top: 52px;
        .barCode{
          display: inline-block;
          width: 110px;
          height: 140px;
          background-color: #fff;
          margin-left: 42px;
          img{
            display: block;
            width: 100px;
            height: 100px;
            margin: 5px;
            vertical-align: middle;
          }
          h5{
            width: 110px;
            height: 30px;
            font-weight: 400;
            background-color: #007BF9;
            line-height: 30px;
            text-align: center;
          }
        }
      }
    }
  }
  .bdBlue{
    border-bottom: 3px solid #409fee;
  }
  // .inputWidth{
  //   animation: inputWidth 1s ease forwards;
  // }
  // @keyframes inputWidth {
  //   0% {
  //     width: 0px;
  //     border-bottom: none;
  //   }
  //   100% {
  //     width: 160px;
  //     border-bottom: 2px solid #666;
  //   }
  // }
</style>
